import CommonApi from './common'
import ProductApi from './product'
import MaintenanceApi from './maintenance'
import ArticlesApi from './articles'
import DocumentsApi from './documents'
import SparePartsApi from './spareParts'
import AboutApi from './about'
import Banner from './banner'

export default {
  ...CommonApi,
  ...ProductApi,
  ...MaintenanceApi,
  ...ArticlesApi,
  ...DocumentsApi,
  ...SparePartsApi,
  ...AboutApi,
  ...Banner
}
